import React, { useEffect } from "react";
import "./About.css";

const About = () => {
    useEffect(() => {
        const elements = document.querySelectorAll(".fade-up-text");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            {
                threshold: 0.2, // when 20% visible
            }
        );

        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);


    useEffect(() => {
        const counters = document.querySelectorAll(".counter");

        const speed = 200; // smaller = faster

        const runCounter = (counter) => {
            const target = +counter.getAttribute("data-target");
            let count = 0;

            const updateCount = () => {
                const increment = target / speed;

                if (count < target) {
                    count += increment;
                    counter.innerText = Math.floor(count).toLocaleString();
                    requestAnimationFrame(updateCount);
                } else {
                    counter.innerText = target.toLocaleString();
                }
            };

            updateCount();
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    runCounter(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        counters.forEach((counter) => observer.observe(counter));

    }, []);

    return (
        <>
            {/* Inner Banner */}
            <div className="inner-banner-wrapper">
                <img
                    src="images/page-banner/about.png"
                    alt="Building Header"
                    className="inner-banner-img"
                />
                <div className="inner-banner-overlay">
                    <div className="inner-banner-text">About</div>
                </div>
            </div>

            {/* About Section */}
            <section className="rts-about-university rts-section-padding">
                <div className="containerabout">

                    {/* Title Row */}
                    <div className="rts-section">
                        <div className="about-title">
                            <h3 className="rts-section-title">Techno India Group In Focus</h3>
                        </div>
                        <div className="about-desc">
                            <p className="rts-section-description fade-up-text">
                                With the passage of time, Techno India Group has not only become one of the leading knowledge ecosystems in modern India, but also expanded its area of expertise significantly to make impactful footprints in the domain of healthcare, hospitality, media, sports and consultancy.
                            </p>
                        </div>
                    </div>

                    {/* Image + Stats */}
                    <div className="about-flex">
                        <div className="about-image">
                            <div className="rts-about-section">
                                <img src="/images/about/about-01.jpg" alt="About" />
                            </div>
                        </div>

                        <div className="about-stats">
                            <div className="rts-about-details">
                                <div className="single-about-info">
                                    <div className="content">
                                        <h3 className="counter" data-target="20000">0</h3>
                                        <img src="/images/icon/11.svg" alt="" />
                                    </div>
                                    <div className="desc">
                                        <p>undergraduate and graduate students</p>
                                    </div>
                                </div>

                                <div className="single-about-info">
                                    <div className="content">
                                        <h3 className="counter" data-target="16214">0</h3>
                                        <img src="/images/icon/12.svg" alt="" />
                                    </div>
                                    <div className="desc">
                                        <p>University Faculty and Staff</p>
                                    </div>
                                </div>

                                <div className="single-about-info">
                                    <div className="content">
                                        <h3 className="counter" data-target="300000">0</h3>
                                        <img src="/images/icon/13.svg" alt="" />
                                    </div>
                                    <div className="desc">
                                        <p>Alumni Worldwide</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>


            {/* History */}
            <section className="rts-history">
                <div className="containerabout">

                    <div className="history-flex">

                        <div className="history-image">
                            <div className="rts-history-image">
                                <img
                                    src="images/about/history.jpg"
                                    alt="History"
                                />
                            </div>
                        </div>

                        <div className="history-content">
                            <div className="rts-history-section">
                                <h4 className="rts-section-title mb-30">
                                    Who We Are
                                </h4>
                                <p className="fade-up-text">

                                    It all started in the mid 1980s, inside a small room in Hooghly, as a training centre.
                                    Today, Techno India Group stands tall as a testament to the promise of delivering world-
                                    class education, in sync with the fast-changing, tech-first academic landscape. Four
                                    decades ago, the Roychowdhury brothers from Kapasdanga, Hooghly envisioned of an
                                    India, where students will be thriving at par with the global standards. With the passage
                                    of time, Techno India Group has not only become one of the leading knowledge
                                    ecosystems in modern India, but also expanded its area of expertise significantly to make
                                    impactful footprints in the domain of healthcare, hospitality, media, sports and
                                    consultancy.
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
            </section>


            {/* Mission & Vision */}
            <section className="rts-mission">
                <div className="containerabout">
                    <div className="rt-center mb-30">
                        <h2 className="rts-section-title">Our Mission and Vision</h2>
                    </div>

                    <div className="rts-timeline-section">
                        <div className="rts-timeline-content">
                            <div className="left-side">
                                <TimelineItem
                                    title="Mission"
                                    text="At Techno India, our unwavering dedication to excellence is a core value that transcends boundaries and serves as our greatest strength. We are steadfast in our commitment to continuously evolve and adapt to the ever-changing needs of the times. With our abundant resources and unwavering commitment, we relentlessly pursue perfection today while actively working towards a brighter future."
                                    img="images/about/mission-1.jpg"
                                />
                                <TimelineItem
                                    title="Excellence"
                                    text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
                                    img="images/about/mission-2.jpg"
                                />
                            </div>

                            <div className="separator"></div>

                            <div className="right-side">
                                <TimelineItem
                                    title="Vision"
                                    text="Techno India is deeply dedicated to revolutionizing the boundaries of possibilities for individuals eager to acquire knowledge. We empower those with an entrepreneurial drive to foster innovation, possess the compassion to utilize education for the betterment of humanity, and possess the foresight to recognize the boundless potential of technology. As a leading institution in the education sector, particularly in engineering, Techno India provides a nurturing environment that encourages students to explore their potential and achieve excellence."
                                    img="images/about/mission-3.jpg"
                                />
                                <TimelineItem
                                    title="Academic Excellence"
                                    text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
                                    img="images/about/mission-4.jpg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* MD Desk */}
            <section className="rts-md rts-section-padding">
                <div className="containerabout">
                    <div className="rts-md-box">
                        <div className="md-item rt-flex">
                            <div className="md-image">
                                <img
                                    src="images/about/md_sir.jpg"
                                    alt="MD"
                                />
                            </div>
                            <div>
                                <div className="single-testimonial fade-up-text ">
                                    <h4 className="rts-section-title mb-30">From MD's Desk</h4>

                                    <div className="rt-between mb--50">
                                        <div className="rt-icon">
                                            <img
                                                src="/images/icon/quote.svg"
                                                alt="quote icon"
                                            />
                                        </div>
                                    </div>

                                    <p className="testimonial-text">
                                        Techno India group is a dynamic organization whose primary focus is
                                        education. As a group, we sincerely believe that India’s comparative
                                        advantage in the global economy lies in education. India’s assimilation
                                        with the globalization process has challenged TIG to offer programmes
                                        that are in tune with the changing needs of the day. We have tried to
                                        meet that challenge with sustained efforts in strengthening our academic
                                        curriculum and course offerings, at the same time maintaining our core
                                        mission and values.
                                    </p>

                                    <div className="rt-testimonial-author mt--50">
                                        <div className="rt-author-meta rt-flex rt-gap-20">
                                            <div className="rt-author-info">
                                                <h5 className="mb-1">Mr. Satyam Roychowdhury</h5>
                                                <p>Managing Director, Techno India Group</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

/* Reusable Components */


const TimelineItem = ({ title, text, img }) => (
    <div className="single-timeline-item">
        <h5>{title}</h5>
        <p className="fade-up-text">{text}</p>
        <img src={img} alt={title} />
    </div>
);

export default About;
